import React,{useEffect, useState} from 'react'
import PostingList from './PostingList';
import { Link } from 'react-router-dom';
import styles from './ProfilePagePosts.module.css'

const ProfilePagePosts = (appRefresh) => { 
    const [userID, setUserID] = useState("")
    const [responseMessage, setResponseMessage] = useState("");
    const [error, setError] = useState(null);
    const [posts, setPosts] = useState({});
    const [isLoaded, setIsLoaded] = useState(false);
    
    const [editingPostId, setEditingPostId] = useState(null);
    const [title, setTitle] = useState("");
    const [communityId, setCommunityId] = useState("");
    const [content, setContent] = useState("");
    const [image, setImage] = useState(null);
    //const [fileURL, setFileURL] = useState("");


    useEffect(() => {
        fetch(
          `${process.env.REACT_APP_API_PATH}/users/${sessionStorage.getItem(
            "user"
          )}`,
          {
            method: "get",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
          .then((res) => res.json())
          .then((result) => {
            if (result && result.attributes) {
              console.log(result)
              setUserID(result.id)
            }
          })
          .catch((error) => {
            alert("error!");
            setResponseMessage("Issue Retrieving Your Data");
            setTimeout(() => {
              setResponseMessage("");
            }, 2000);
          });
      }, []);

      useEffect(() => { 
        loadPosts();
      }, [userID])

    const loadPosts = () => {
      // if the user is not logged in, we don't want to try loading posts, because it will just error out.
      if (sessionStorage.getItem("token") && userID) {
          console.log(userID)
        let url = process.env.REACT_APP_API_PATH + `/posts?authorID=${userID}`;
  
        // make an api request to fetch all the posts which are original posts (not comments/don't have a parentId)
        fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        })
          .then((res) => res.json())
          .then((result) => {
            if (result) {
              console.log(result)
              setIsLoaded(true);
              setPosts(result[0]);
              console.log("Got Posts");
            }
          })
          .catch((err) => {
            setIsLoaded(true);
            setError(err);
            console.log("ERROR loading posts");
          });
      }
    };

    const showCreated = (date) => {
      date = new Date(date);
      const options = {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      };
      const formattedDateString = new Intl.DateTimeFormat('en-US', options).format(date);
  
      return (
        <span>Created: {formattedDateString}</span>
      );
    };

    const uploadImage = async () => {
      const formData = new FormData();
      formData.append("uploaderID", sessionStorage.getItem("user"));
      formData.append("attributes", JSON.stringify({}));
      formData.append("file", image);

      const response = await fetch(`${process.env.REACT_APP_API_PATH}/file-uploads`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`
        },
        body: formData
      })

      const result = await response.json();
      //setFileURL("https://webdev.cse.buffalo.edu" + result.path)
      return "https://webdev.cse.buffalo.edu" + result.path
    }

    const handleSubmit = async (event) => {
      event.preventDefault();
      // Update the post here
      const formData = {
        authorID: sessionStorage.getItem("user"),
        attributes : {},
      };

      //Construct FormData object
      if (image) {
        //Upload the Image first and get the url back
        const fileURL = await uploadImage()
        console.log(`fileURL is : ${fileURL}`)
        formData.attributes.fileURL = fileURL;
      } else {
          if (document.getElementById('fileURL')) {
            formData.attributes.fileURL = document.getElementById('fileURL').defaultValue
          }
      }

      if (content !== "") { formData.content = content; } else { formData.content = document.getElementById('content').defaultValue;}
      if (title !== "") { formData.attributes.title = title; } else { formData.attributes.title = document.getElementById('title').defaultValue; }
      if (communityId !== "") { formData.attributes.CommunityID = communityId; } else { formData.attributes.CommunityID = document.getElementById('community').options[document.getElementById('community').selectedIndex].value; }

      
      let recipientGroupID = null;
      
      if (formData.attributes.CommunityID === "FPS") {
        recipientGroupID = 69;
      }
      else if (formData.attributes.CommunityID === "Battle Royale") {
        recipientGroupID = 70;
      }
      else if (formData.attributes.CommunityID === "Sandbox") {
        recipientGroupID = 71;
      }
      else if (formData.attributes.CommunityID === "Action-adventure") {
        recipientGroupID = 72;
      }
      else if (formData.attributes.CommunityID === "MOBA") {
        recipientGroupID = 73;
      }
      else {
        recipientGroupID = null;
      }


      formData.recipientGroupID = recipientGroupID;


      console.log(formData)
      console.log(title, communityId, content, image)
      await fetch(`${process.env.REACT_APP_API_PATH}/posts/${editingPostId}`, {
        method : "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("token")}`
        },
        body : JSON.stringify(formData)
      })
      .then((res) => res.json())
      .then((result) => {
        console.log(result)
      })
      
      // Reset the form
      setTitle("");
      setCommunityId("");
      setContent("");
      setImage(null);

      // Reset the editing post id
      setEditingPostId(null);

      loadPosts();

    }

    function getRandomColor() {
      return '#' + Math.floor(Math.random() * 16777215).toString(16);
    };


  return (
      <div className={styles.container}>
          <Link to={'/profile'} className={styles.backBtn}>Back</Link>
          <h1>Your Posts</h1>
          <div id="PostListContainer" className ={styles.postsListContainer}>
              {posts.length > 0 ? (
                  posts.map((post, index) => (
                      <div key={index} style={{ marginBottom: '20px' }}>
                          {editingPostId === post.id ? (
                            <div className={styles.postContainer} style={{ borderTop: `3px solid ${getRandomColor()}` }}>
                              <form>
                                  <label htmlFor='title'>Title : </label>
                                  <input id='title' className = {styles.inputField} defaultValue={post.attributes.title} onChange={e => setTitle(e.target.value)} />
                                  <label htmlFor='community'>Community : </label>
                                  <select
                                      id='community' 
                                      defaultValue={post.attributes.CommunityID}
                                      onChange={e => setCommunityId(e.target.value)}
                                      className={styles.dropdown}
                                  > 
                                      <option value="" disabled>Please Select a Community</option>
                                      <option value="FPS">FPS</option>
                                      <option value="Battle Royale">Battle Royale</option>
                                      <option value="MOBA">MOBA</option>
                                      <option value="Sandbox">Sandbox</option>
                                      <option value="Other">Other</option>
                                  </select>
                                  <br/>
                                  <input id="fileURL" className={styles.fileUpload} defaultValue={post.attributes.fileURL} style={{display : 'none'}}></input>
                                  <br/>
                                  <label htmlFor='imageUpload'>Upload an Image : </label>
                                  <input id="imageUpload" type="file" accept="image/*" onChange={e => setImage(e.target.files[0])} />
                                  <br/><br/>
                                  <label htmlFor='content'>Content : </label>
                                  <textarea id='content' className={styles.contentField} defaultValue={post.content} onChange={e => setContent(e.target.value)} />
                                  <br/>

                                  <button className={styles.saveBtn} onClick={handleSubmit}>Save</button>
                                  <button className={styles.closeBtn} type="button" onClick={() => setEditingPostId(null)}>Cancel</button>
                                  <br/><br/>
                              </form>
                              <br/><br/>
                            </div>
                          ) : (
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#34393D', borderRadius : '20px', width : '500px'}}>
                              {/* <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}> */}
                                <h2 className={styles.postTitle}>{post.attributes.title}</h2>
                                {/* <div style={{ marginRight: '10px' }}>{`Community : ${post.attributes.CommunityID}`}</div> */}
                              {/* </div> */}
                              {post.attributes.fileURL ? 
                                <img src={post.attributes.fileURL} alt="Post Image" className={styles.post_img} />
                                : null
                              }
                              <p>{post.content}</p>
                              <div>{showCreated(post.created)}</div>
                              <button className={styles.editBtn} onClick={() => setEditingPostId(post.id)}>Edit Post</button>
                            </div>
                          )}
                      </div>
                  ))
              ) : (
                  <p>No posts found</p>
              )}
          </div>
      </div>
  );
}

export default ProfilePagePosts